/**
 * @module ol/source/common
 */
/**
 * Default WMS version.
 * @type {string}
 */
export var DEFAULT_WMS_VERSION = '1.3.0';
//# sourceMappingURL=common.js.map